import React, { useState } from "react";
import { Box, Button, styled } from "@mui/material";
import { motion } from "framer-motion";

const TabWrapper = styled(Box)(({ theme }) => ({
  display: "inline-flex",
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: "8px",
  backgroundColor: theme.palette.background.paper,
  padding: "2px",
  position: "relative",
}));

const TabButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "selected",
})(({ theme, selected }) => ({
  minWidth: 100,
  padding: "6px 14px",
  fontSize: "13px",
  fontWeight: 600,
  color: selected ? theme.palette.primary.main : theme.palette.text.secondary,
  backgroundColor: "transparent",
  borderRadius: "6px",
  zIndex: 1,
  textTransform: "none",
  position: "relative",
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
    color: theme.palette.primary.main,
  },
}));

const ActiveUnderline = styled(motion.div)(({ theme }) => ({
  position: "absolute",
  bottom: 2,
  height: "3px",
  borderRadius: "3px",
  backgroundColor: theme.palette.primary.main,
  zIndex: 0,
}));

const ButtonTabs = () => {
  const [activeTab, setActiveTab] = useState("All");

  const tabs = [
    { id: "All", label: "All" },
    { id: "Approve", label: "Approve" },
    { id: "Pending", label: "Pending" },
  ];

  return (
    <Box>
      <TabWrapper>
        {tabs.map((tab, index) => {
          const isActive = activeTab === tab.id;

          return (
            <Box key={tab.id} sx={{ position: "relative" }}>
              {isActive && (
                <ActiveUnderline
                  layoutId="underline"
                  transition={{ type: "spring", stiffness: 400, damping: 30 }}
                  style={{
                    left: 0,
                    right: 0,
                    width: "100%",
                  }}
                />
              )}
              <TabButton
                selected={isActive}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </TabButton>
            </Box>
          );
        })}
      </TabWrapper>
    </Box>
  );
};

export default ButtonTabs;
